// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/a2ui/v1/surface.proto" (package "c1.api.a2ui.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { A2UIComponent } from "./components";
/**
 * A2UISurface represents a rendered UI surface within a conversation.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UISurface
 */
export interface A2UISurface {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string conversation_id = 2
     */
    conversationId: string;
    /**
     * @generated from protobuf field: string surface_id = 3
     */
    surfaceId: string;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.SurfaceLifecycleState state = 4
     */
    state: SurfaceLifecycleState;
    /**
     * @generated from protobuf field: string catalog_id = 5
     */
    catalogId: string; // e.g., "c1/a2ui/access-request/v1"
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.A2UIComponent components = 6
     */
    components: A2UIComponent[];
    /**
     * @generated from protobuf field: string data_model_json = 7
     */
    dataModelJson: string; // JSON string containing bound data
    /**
     * @generated from protobuf field: int64 schema_version = 8
     */
    schemaVersion: number; // For client reconciliation
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 9
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 10
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 11
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool send_data_model = 12
     */
    sendDataModel: boolean; // A2UI v0.9 pattern - send full data model with actions
}
/**
 * SurfaceLifecycleState tracks the surface's lifecycle.
 *
 * @generated from protobuf enum c1.api.a2ui.v1.SurfaceLifecycleState
 */
export enum SurfaceLifecycleState {
    /**
     * @generated from protobuf enum value: SURFACE_LIFECYCLE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Interactive, user can interact
     *
     * @generated from protobuf enum value: SURFACE_LIFECYCLE_STATE_ACTIVE = 1;
     */
    ACTIVE = 1,
    /**
     * Action completed, dimmed, non-interactive
     *
     * @generated from protobuf enum value: SURFACE_LIFECYCLE_STATE_COMPLETE = 2;
     */
    COMPLETE = 2,
    /**
     * Hidden, not rendered
     *
     * @generated from protobuf enum value: SURFACE_LIFECYCLE_STATE_DELETED = 3;
     */
    DELETED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class A2UISurface$Type extends MessageType<A2UISurface> {
    constructor() {
        super("c1.api.a2ui.v1.A2UISurface", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.a2ui.v1.SurfaceLifecycleState", SurfaceLifecycleState, "SURFACE_LIFECYCLE_STATE_"] },
            { no: 5, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => A2UIComponent },
            { no: 7, name: "data_model_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "schema_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 9, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "send_data_model", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<A2UISurface>): A2UISurface {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.conversationId = "";
        message.surfaceId = "";
        message.state = 0;
        message.catalogId = "";
        message.components = [];
        message.dataModelJson = "";
        message.schemaVersion = 0;
        message.sendDataModel = false;
        if (value !== undefined)
            reflectionMergePartial<A2UISurface>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UISurface): A2UISurface {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                case /* string surface_id */ 3:
                    message.surfaceId = reader.string();
                    break;
                case /* c1.api.a2ui.v1.SurfaceLifecycleState state */ 4:
                    message.state = reader.int32();
                    break;
                case /* string catalog_id */ 5:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.a2ui.v1.A2UIComponent components */ 6:
                    message.components.push(A2UIComponent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string data_model_json */ 7:
                    message.dataModelJson = reader.string();
                    break;
                case /* int64 schema_version */ 8:
                    message.schemaVersion = reader.int64().toNumber();
                    break;
                case /* google.protobuf.Timestamp created_at */ 9:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 10:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 11:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* bool send_data_model */ 12:
                    message.sendDataModel = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UISurface, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string conversation_id = 2; */
        if (message.conversationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        /* string surface_id = 3; */
        if (message.surfaceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.surfaceId);
        /* c1.api.a2ui.v1.SurfaceLifecycleState state = 4; */
        if (message.state !== 0)
            writer.tag(4, WireType.Varint).int32(message.state);
        /* string catalog_id = 5; */
        if (message.catalogId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.a2ui.v1.A2UIComponent components = 6; */
        for (let i = 0; i < message.components.length; i++)
            A2UIComponent.internalBinaryWrite(message.components[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string data_model_json = 7; */
        if (message.dataModelJson !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dataModelJson);
        /* int64 schema_version = 8; */
        if (message.schemaVersion !== 0)
            writer.tag(8, WireType.Varint).int64(message.schemaVersion);
        /* google.protobuf.Timestamp created_at = 9; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 10; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 11; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool send_data_model = 12; */
        if (message.sendDataModel !== false)
            writer.tag(12, WireType.Varint).bool(message.sendDataModel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UISurface
 */
export const A2UISurface = new A2UISurface$Type();
